// 保存医生token信息
export const SET_DOCTOR_TOKEN = 'SET_DOCTOR_TOKEN';
// 清除医生token信息
export const CLEAR_CLINIC_TOKEN = 'CLEAR_CLINIC_TOKEN';
// 保存医生首页信息
export const SAVEDOCTORINDEX = 'SAVEDOCTORINDEX';
//保存医生个人中心信息
export const SAVEDOCTORCENTER = 'SAVEDOCTORCENTER';
//切换状态
export const TOGGLEINDEX = 'TOGGLEINDEX';
//选择患者
export const CHOOSEPATIENT = 'CHOOSEPATIENT';
//视频进入途径
export const ENTERROOMWAY = 'ENTERROOMWAY';
//保存问诊单详情
export const SAVEINQUIRY = 'SAVEINQUIRY';

//保存问诊单详情
export const SELECTMEDICAL = 'SELECTMEDICAL';
//保存视频患者数据
export const SET_VIDEO_PATIENT = 'SET_VIDEO_PATIENT';
// 保存医生登录使用的手机号码
export const SAVE_LOGIN_PHONE = 'SAVE_LOGIN_PHONE';
// 保存摄像头信息
export const SET_CAMERA_INFO = 'SET_CAMERA_INFO';


// WEBPACK FOOTER //
// ./src/store/common/mutations_type.js